import { render, staticRenderFns } from "./PartnerCreditList.vue?vue&type=template&id=0d51e1dd"
import script from "./PartnerCreditList.vue?vue&type=script&lang=js"
export * from "./PartnerCreditList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports